import * as React from 'react'
import { useNavigatorOnLine } from '../hooks/networkStatusHook.js'

export default function NetworkStatusIndicator ({ lang }) {
  const isOnline = useNavigatorOnLine()

  if (isOnline) {
    return null
  }

  return (
    <div className='z-50 absolute inset-x-0 top-0 flex items-center gap-x-6 bg-red-500 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 transitiona-all duration-75 ease-in delay-150'>
      <p className='md:text-sm text-xs leading-6 text-white'>
        {lang.noInternetConnection}
      </p>
    </div>
  )
};
